import { useMediaQuery } from "@/hooks/use-media-query";
import { useSecoesScroll } from "@/shared/hooks";
import {
  EMBARCACAO_DETAIL_MENU_LABEL,
  EMBARCACAO_DETAIL_MOBILE_QUERY,
  EMBARCACAO_DETAIL_TITLE,
} from "./embarcacao-detail-dialog.constants";
import { EMBARCACAO_DETAIL_SECTIONS } from "./sections";
import type { EmbarcacaoDetailDialogProps } from "./types-embarcacao-detail-dialog";

/**
 * Modal Detalhes da Embarcação: casca de detalhamento somente leitura, sobreposta à listagem (AC1).
 *
 * A casca não conhece nenhuma seção: monta o menu lateral e o corpo rolável a partir do registro de seções, de modo
 * que uma seção nova entre no detalhamento sem tocar aqui (AC2). Nenhuma escrita é disparada na abertura ou no
 * fechamento: a consulta de cada seção é a única chamada feita (RN003).
 */
export function useEmbarcacaoDetailDialog({
  embarcacaoId,
  onClose,
  onReauthenticate,
  sections = EMBARCACAO_DETAIL_SECTIONS,
}: EmbarcacaoDetailDialogProps) {
  // A primeira seção registrada é a ativa quando o modal abre (AC2).
  const scroll = useSecoesScroll(sections[0]?.id ?? "");
  // No mobile o menu lateral dá lugar a um seletor de seções no topo do corpo.
  const isMobile = useMediaQuery(EMBARCACAO_DETAIL_MOBILE_QUERY);

  return {
    title: EMBARCACAO_DETAIL_TITLE,
    isMobile,
    embarcacaoId,
    sections,
    onReauthenticate,
    fechar: onClose,
    menu: {
      items: sections.map((section) => ({
        id: section.id,
        title: section.title,
        testId: `embarcacao-detail-menu-${section.id}`,
      })),
      activeId: scroll.activeId,
      onSelect: scroll.selecionar,
      isMobile,
      label: EMBARCACAO_DETAIL_MENU_LABEL,
      testId: "embarcacao-detail-menu",
      selectTestId: "embarcacao-detail-section-select",
    },
    // Figma mobile: o botão do detalhe é small (31); no desktop, 35.
    exportarSize: isMobile ? ("small" as const) : undefined,
    bodyRef: scroll.bodyRef,
    propsCorpo: scroll.propsCorpo,
  };
}
